/** Mask mobile: first 2 and last 4 digits visible (handles optional country code). */
export function maskMobileNumber(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length < 6) {
    if (trimmed.length <= 4) return '****';
    const first2 = trimmed.slice(0, 2);
    const last4 = trimmed.slice(-4);
    const middleLen = Math.max(trimmed.length - 6, 1);
    return `${first2}${'*'.repeat(middleLen)}${last4}`;
  }

  let core = digits;
  let prefix = '';
  if (digits.length > 10) {
    const cc = digits.slice(0, digits.length - 10);
    prefix = cc ? `+${cc}` : '';
    core = digits.slice(-10);
  }

  const first2 = core.slice(0, 2);
  const last4 = core.slice(-4);
  const stars = '*'.repeat(Math.max(core.length - 6, 1));
  return `${prefix}${first2}${stars}${last4}`;
}

export function looksLikePhoneNumber(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 6;
}
